import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@aisquare/ui";
import App from "./App";
import { THEME_STORAGE_KEY } from "./lib/theme";
import "./global.css";

/**
 * The playground runs on the library's own `<ThemeProvider>` rather than a
 * local light/dark toggle, so the light / dark / system cascade being QA'd is
 * the same code a consumer app ships. `index.html` inlines the matching
 * pre-paint script against the same storage key, so the first frame is already
 * in the resolved theme.
 *
 * Defaults to `dark`, not `system`: the brand reads as deep navy, and that is
 * the face the playground should open on rather than one that depends on the
 * visitor's OS. All three options stay in the header control, and a stored
 * preference still wins over this default. Keep it in step with the fallback
 * in `index.html`'s pre-paint script — if the two disagree, the first frame
 * paints one theme and React immediately repaints the other.
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="dark" storageKey={THEME_STORAGE_KEY}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
